// extracted by mini-css-extract-plugin
module.exports = {"termsPage":"_17vb7","termsList":"_3OaK1","termsSubList":"EI6nL"};